// Compute slug from a given text
export const sanitizeSlug = text => {
  let slug = "";
  const titleLower = text ? text.toLowerCase() : '';
  // Letter "e"
  slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
  // Letter "a"
  slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
  // question mark
  slug = slug.replace(/\?/gi, '');
  // back slash
  slug = slug.replace(/\//gi, '');
  // forward slash
  slug = slug.replace(/\\/gi, '');
  // Letter "o"
  slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
  // Letter "u"
  slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
  // Letter "d"
  slug = slug.replace(/đ/gi, 'd');
  // Change whitespace to "-"
  slug = slug.replace(/\s+/g, '-');
  // Don't include %s
  slug = slug.replace(/%/g, 'percent')

  return slug;
}

export const merge = categories => {
  return categories.reduce((acc, category) => {
    const sections = category.sections.reduce((acc, section) => {
      return [...acc, section]
    }, [])

    return [...acc, {...category}, ...sections]
  }, [])
}

export const parseFetchArticleResponse = response => {
  const responseDocument = response.document

  const parser = new DOMParser()
  const doc = parser.parseFromString(responseDocument, 'text/html')

  if (doc == null) {
    return response
  }

  const iconWrappers = doc.querySelectorAll('.article-callout-icon-wrapper')
  const calloutContents = doc.querySelectorAll('.article-callout-textarea')

  iconWrappers.forEach(iconWrapper => {
    iconWrapper.remove()
  })

  calloutContents.forEach(calloutContent => {
    calloutContent.parentNode.innerHTML = calloutContent.innerHTML
  })

  const infoCallouts = doc.querySelectorAll('.article-callout-paragraph-container--info')
  infoCallouts.forEach(infoCallout => infoCallout.classList.add('article-info-callout-new'))

  const noteCallouts = doc.querySelectorAll('.article-callout-paragraph-container--note')
  noteCallouts.forEach(noteCallout => noteCallout.classList.add('article-note-callout-new'))

  const warningCallouts = doc.querySelectorAll('.article-callout-paragraph-container--warning')
  warningCallouts.forEach(warningCallout => warningCallout.classList.add('article-warning-callout-new'))


  response.document = doc.getElementsByTagName('body')[0].innerHTML
  return response
}

export const reorderArrayItems = (eventData, arr) => {
  const { oldIndex, newIndex } = eventData

  const movedItem = arr.find((arrItem, index) => index === oldIndex)
  const remainingItems = arr.filter((arrItem, index) => index !== oldIndex)

  return [
    ...remainingItems.slice(0, newIndex),
    movedItem,
    ...remainingItems.slice(newIndex)
  ]
}
